var map = {
	"./matilde-angry.png": 126,
	"./matilde-bored.png": 127,
	"./matilde-cap-brazil-angry.png": 128,
	"./matilde-cap-brazil-bored.png": 129,
	"./matilde-cap-brazil-happy.png": 130,
	"./matilde-cap-brazil-hello.png": 131,
	"./matilde-cap-brazil-impressed.png": 132,
	"./matilde-cap-brazil-normal.png": 133,
	"./matilde-cap-brazil-sad.png": 134,
	"./matilde-cap-brazil-scary.png": 135,
	"./matilde-cap-brazil-sleepy.png": 136,
	"./matilde-cap-brazil-thinking.png": 137,
	"./matilde-cap-brazil-tired.png": 138,
	"./matilde-cap-china-angry.png": 139,
	"./matilde-cap-china-bored.png": 140,
	"./matilde-cap-china-happy.png": 141,
	"./matilde-cap-china-hello.png": 142,
	"./matilde-cap-china-impressed.png": 143,
	"./matilde-cap-china-normal.png": 144,
	"./matilde-cap-china-sad.png": 145,
	"./matilde-cap-china-scary.png": 146,
	"./matilde-cap-china-sleepy.png": 147,
	"./matilde-cap-china-thinking.png": 148,
	"./matilde-cap-china-tired.png": 149,
	"./matilde-cap-greece-angry.png": 150,
	"./matilde-cap-greece-bored.png": 151,
	"./matilde-cap-greece-happy.png": 152,
	"./matilde-cap-greece-hello.png": 153,
	"./matilde-cap-greece-impressed.png": 154,
	"./matilde-cap-greece-normal.png": 155,
	"./matilde-cap-greece-sad.png": 156,
	"./matilde-cap-greece-scary.png": 157,
	"./matilde-cap-greece-sleepy.png": 158,
	"./matilde-cap-greece-thinking.png": 159,
	"./matilde-cap-greece-tired.png": 160,
	"./matilde-cap-sri-lanka-angry.png": 161,
	"./matilde-cap-sri-lanka-bored.png": 162,
	"./matilde-cap-sri-lanka-happy.png": 163,
	"./matilde-cap-sri-lanka-hello.png": 164,
	"./matilde-cap-sri-lanka-impressed.png": 165,
	"./matilde-cap-sri-lanka-normal.png": 166,
	"./matilde-cap-sri-lanka-sad.png": 167,
	"./matilde-cap-sri-lanka-scary.png": 168,
	"./matilde-cap-sri-lanka-sleepy.png": 169,
	"./matilde-cap-sri-lanka-thinking.png": 170,
	"./matilde-cap-sri-lanka-tired.png": 171,
	"./matilde-happy.png": 172,
	"./matilde-hat-brazil-angry.png": 173,
	"./matilde-hat-brazil-bored.png": 174,
	"./matilde-hat-brazil-happy.png": 175,
	"./matilde-hat-brazil-hello.png": 176,
	"./matilde-hat-brazil-impressed.png": 177,
	"./matilde-hat-brazil-normal.png": 178,
	"./matilde-hat-brazil-sad.png": 179,
	"./matilde-hat-brazil-scary.png": 180,
	"./matilde-hat-brazil-sleepy.png": 181,
	"./matilde-hat-brazil-thinking.png": 182,
	"./matilde-hat-brazil-tired.png": 183,
	"./matilde-hat-china-angry.png": 184,
	"./matilde-hat-china-bored.png": 185,
	"./matilde-hat-china-happy.png": 186,
	"./matilde-hat-china-hello.png": 187,
	"./matilde-hat-china-impressed.png": 188,
	"./matilde-hat-china-normal.png": 189,
	"./matilde-hat-china-sad.png": 190,
	"./matilde-hat-china-scary.png": 191,
	"./matilde-hat-china-sleepy.png": 192,
	"./matilde-hat-china-thinking.png": 193,
	"./matilde-hat-china-tired.png": 194,
	"./matilde-hat-greece-angry.png": 195,
	"./matilde-hat-greece-bored.png": 196,
	"./matilde-hat-greece-happy.png": 197,
	"./matilde-hat-greece-hello.png": 198,
	"./matilde-hat-greece-impressed.png": 199,
	"./matilde-hat-greece-normal.png": 200,
	"./matilde-hat-greece-sad.png": 201,
	"./matilde-hat-greece-scary.png": 202,
	"./matilde-hat-greece-sleepy.png": 203,
	"./matilde-hat-greece-thinking.png": 204,
	"./matilde-hat-greece-tired.png": 205,
	"./matilde-hat-sri-lanka-angry.png": 206,
	"./matilde-hat-sri-lanka-bored.png": 207,
	"./matilde-hat-sri-lanka-happy.png": 208,
	"./matilde-hat-sri-lanka-hello.png": 209,
	"./matilde-hat-sri-lanka-impressed.png": 210,
	"./matilde-hat-sri-lanka-normal.png": 211,
	"./matilde-hat-sri-lanka-sad.png": 212,
	"./matilde-hat-sri-lanka-scary.png": 213,
	"./matilde-hat-sri-lanka-sleepy.png": 214,
	"./matilde-hat-sri-lanka-thinking.png": 215,
	"./matilde-hat-sri-lanka-tired.png": 216,
	"./matilde-hello.png": 217,
	"./matilde-impressed.png": 218,
	"./matilde-normal.png": 219,
	"./matilde-sad.png": 220,
	"./matilde-scary.png": 221,
	"./matilde-sleepy.png": 222,
	"./matilde-special-adventour-angry.png": 223,
	"./matilde-special-adventour-bored.png": 224,
	"./matilde-special-adventour-happy.png": 225,
	"./matilde-special-adventour-hello.png": 226,
	"./matilde-special-adventour-impressed.png": 227,
	"./matilde-special-adventour-normal.png": 228,
	"./matilde-special-adventour-sad.png": 229,
	"./matilde-special-adventour-scary.png": 230,
	"./matilde-special-adventour-sleepy.png": 231,
	"./matilde-special-adventour-thinking.png": 232,
	"./matilde-special-adventour-tired.png": 233,
	"./matilde-special-crown-angry.png": 234,
	"./matilde-special-crown-bored.png": 235,
	"./matilde-special-crown-happy.png": 236,
	"./matilde-special-crown-hello.png": 237,
	"./matilde-special-crown-impressed.png": 238,
	"./matilde-special-crown-normal.png": 239,
	"./matilde-special-crown-sad.png": 240,
	"./matilde-special-crown-scary.png": 241,
	"./matilde-special-crown-sleepy.png": 242,
	"./matilde-special-crown-thinking.png": 243,
	"./matilde-special-crown-tired.png": 244,
	"./matilde-special-indiana-angry.png": 245,
	"./matilde-special-indiana-bored.png": 246,
	"./matilde-special-indiana-happy.png": 247,
	"./matilde-special-indiana-hello.png": 248,
	"./matilde-special-indiana-impressed.png": 249,
	"./matilde-special-indiana-normal.png": 250,
	"./matilde-special-indiana-sad.png": 251,
	"./matilde-special-indiana-scary.png": 252,
	"./matilde-special-indiana-sleepy.png": 253,
	"./matilde-special-indiana-thinking.png": 254,
	"./matilde-special-indiana-tired.png": 255,
	"./matilde-thinking.png": 256,
	"./matilde-tired.png": 257
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 576;